// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { FolderSharingInstance } from "./helpers/folderSharingInstanceHelpers";
import { createFolderSharingInstance } from "./helpers/folderSharingInstanceHelpers";
import { createApiFactory } from "@Front/Api/helpers/BaseApiFactoryGenerator";

const factory = createApiFactory<IBaseNotary, FolderSharingInstance>({
	name: "FolderSharing",
	createBase: createBaseNotary,
	createInstance: createFolderSharingInstance,
});

export function getFolderSharingInstance(): FolderSharingInstance {
	return factory.getInstance();
}
